/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_UnchangedInputs */



/**
* | output |
* | --- |
* | "Nothing changed." |
*
* @param {Spaces_Connection_Settings_UnchangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_unchanged = /** @type {((inputs?: Spaces_Connection_Settings_UnchangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_UnchangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Änderungen.")
	return /** @type {LocalizedString} */ ("Nothing changed.")
});